import React, { Component } from 'react';

class SectionRegistrationSteps extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section className="elementor-section elementor-top-section elementor-element elementor-element-2c8b3bce elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="2c8b3bce" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
                <div className="elementor-background-overlay"></div>
                <div className="elementor-container elementor-column-gap-default">
                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-46de8d4f" data-id="46de8d4f" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                            <section className="elementor-section elementor-inner-section elementor-element elementor-element-11a7d0f0 elementor-reverse-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="11a7d0f0" data-element_type="section" id="empreendedor">
                                <div className="elementor-container elementor-column-gap-default">
                                    <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-3eed8ae4" data-id="3eed8ae4" data-element_type="column">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div className="elementor-element elementor-element-1a225867 elementor-widget elementor-widget-text-editor" data-id="1a225867" data-element_type="widget" data-widget_type="text-editor.default">
                                                <div className="elementor-widget-container">
                                                    <p><span style={{ verticalAlign: 'inherit' }}><span style={{ verticalAlign: 'inherit' }}>VEJA COMO COMEÇAR A  </span></span><span style={{ color: '#ef3087' }}><span style={{ verticalAlign: 'inherit' }}><span style={{ verticalAlign: 'inherit' }}>EMPREENDER</span></span></span><span style={{ verticalAlign: 'inherit' }}><span style={{ verticalAlign: 'inherit' }}> COM A </span></span><span style={{ color: '#ef3087' }}><span style={{ verticalAlign: 'inherit' }}><span style={{ verticalAlign: 'inherit' }}>SIG MOBI:</span></span></span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section className="elementor-section elementor-inner-section elementor-element elementor-element-4412ce2a elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="4412ce2a" data-element_type="section">
                                <div className="elementor-container elementor-column-gap-default">
                                    <div className="elementor-column elementor-col-20 elementor-inner-column elementor-element elementor-element-169f8cb2" data-id="169f8cb2" data-element_type="column" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div className="elementor-element elementor-element-4153565a elementor-widget elementor-widget-icon-box" data-id="4153565a" data-element_type="widget" data-widget_type="icon-box.default">
                                                <div className="elementor-widget-container">
                                                    <div className="elementor-icon-box-wrapper">


                                                        <div className="elementor-icon-box-content">

                                                            <h3 className="elementor-icon-box-title">
                                                                <span  >
                                                                    1° PASSO						</span>
                                                            </h3>

                                                            <p className="elementor-icon-box-description">
                                                            Clique no botão verde "QUERO ME CADASTRAR AGORA" e crie sua conta na SIG MOBI. Escolha o perfil que mais se encaixa: passageiro, motorista ou ONG.
                                                            </p>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="elementor-column elementor-col-20 elementor-inner-column elementor-element elementor-element-6da9a98c" data-id="6da9a98c" data-element_type="column" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div className="elementor-element elementor-element-92be44b elementor-widget elementor-widget-icon-box" data-id="92be44b" data-element_type="widget" data-widget_type="icon-box.default">
                                                <div className="elementor-widget-container">
                                                    <div className="elementor-icon-box-wrapper">


                                                        <div className="elementor-icon-box-content">

                                                            <h3 className="elementor-icon-box-title">
                                                                <span  >
                                                                    2° PASSO						</span>
                                                            </h3>

                                                            <p className="elementor-icon-box-description">
                                                            Baixe o aplicativo da SIG MOBI e acesse o menu principal. 					</p>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="elementor-column elementor-col-20 elementor-inner-column elementor-element elementor-element-3cc4b7d7" data-id="3cc4b7d7" data-element_type="column" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div className="elementor-element elementor-element-52e43044 elementor-widget elementor-widget-icon-box" data-id="52e43044" data-element_type="widget" data-widget_type="icon-box.default">
                                                <div className="elementor-widget-container">
                                                    <div className="elementor-icon-box-wrapper">


                                                        <div className="elementor-icon-box-content">

                                                            <h3 className="elementor-icon-box-title">
                                                                <span  >
                                                                    3° PASSO						</span>
                                                            </h3>

                                                            <p className="elementor-icon-box-description">
                                                            Toque em "INDICAR SUA PÁGINA" e compartilhe seu link exclusivo com seus contatos.
                                                            </p>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="elementor-column elementor-col-20 elementor-inner-column elementor-element elementor-element-2e188151" data-id="2e188151" data-element_type="column" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div className="elementor-element elementor-element-68a31fec elementor-widget elementor-widget-icon-box" data-id="68a31fec" data-element_type="widget" data-widget_type="icon-box.default">
                                                <div className="elementor-widget-container">
                                                    <div className="elementor-icon-box-wrapper">


                                                        <div className="elementor-icon-box-content">

                                                            <h3 className="elementor-icon-box-title">
                                                                <span  >
                                                                    4° PASSO						</span>
                                                            </h3>

                                                            <p className="elementor-icon-box-description">
                                                            Cada amigo que se cadastrar e utilizar a SIG MOBI através do seu link, você ganhará créditos na sua conta.
                                                            </p>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="elementor-column elementor-col-20 elementor-inner-column elementor-element elementor-element-581d6cf" data-id="581d6cf" data-element_type="column" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div className="elementor-element elementor-element-55163b52 elementor-widget elementor-widget-icon-box" data-id="55163b52" data-element_type="widget" data-widget_type="icon-box.default">
                                                <div className="elementor-widget-container">
                                                    <div className="elementor-icon-box-wrapper">


                                                        <div className="elementor-icon-box-content">

                                                            <h3 className="elementor-icon-box-title">
                                                                <span  >
                                                                    5° PASSO						</span>
                                                            </h3>

                                                            <p className="elementor-icon-box-description">
                                                                Utilize seus créditos para pedir corridas, acessar outros serviços da plataforma ou transferir o valor para sua conta bancária.
                                                            </p>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div className="elementor-element elementor-element-146a3091 elementor-align-center bt-refer cadastro elementor-widget elementor-widget-button" data-id="146a3091" data-element_type="widget" data-widget_type="button.default">
                                <div className="elementor-widget-container">
                                    <div className="elementor-button-wrapper">
                                        <a className="elementor-button elementor-button-link elementor-size-lg" href={this.props.url} style={{backgroundColor:  '#57c600'}}>
                                            <span className="elementor-button-content-wrapper">
                                                <span className="elementor-button-text">QUERO ME CADASTRAR AGORA</span>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default SectionRegistrationSteps;